module.exports = __webpack_public_path__ + "static/media/jd.8b8524a4.png";